<template>
  <div class="Wx-home">
      <div class="header" v-show="!fullscreen">
        <navhead />
      </div>
      <div class="routerSwitch">
        <span class="fullscreen" v-show="scroolStarrysky" @click="toggleFullScreen">
          <img src="@/assets/fullscreen.png" v-if="!fullscreen" alt="">
          <img src="@/assets/fullscreenMin.png" v-else alt="">
        </span>
        <router-view />
      </div>
      <!-- DeepSeek接口都需要登录才能用————宋柏欣 -->
    <DeepSeek v-if="shouldShowDeepSeek" />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, onBeforeUnmount, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import Cookies from "js-cookie";
import navhead from "../components/wx-Nav-header";
import homeFoolter from "@/components/homeFoolter";
import DeepSeek from "@/views/DeepSeek";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const route = useRoute();

let privatization = window.g.privatization; /// 是否私有化部署， true/是 false/否

const getToken = Cookies.get("tokenValue");

const shouldShowDeepSeek = computed(() => {
  return getToken && !privatization;
});

// 存储滚动位置的变量

const emit = defineEmits(["onGlobalSwitchLang"])

const onGlobalSwitchLang = () => {
  emit("onGlobalSwitchLang")
}

const scroolStarrysky = computed(() => {
  return store.getters.getScroolStarrysky;
});


// 全屏 播放器
const fullscreenElement = ref(1);
const fullscreen = ref(store.getters.getfullscreen);
const toggleFullScreen = () => {
  const element = document.documentElement;
  fullscreenElement.value = document.fullscreenElement;
  if (!document.fullscreenElement) {
    // 如果没有全屏元素，则进入全屏模式
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    fullscreen.value = true;
    store.dispatch("setfullscreen", true);
  } else {
    // 如果已经是全屏模式，则退出全屏
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    fullscreen.value = false;
    store.dispatch("setfullscreen", false);
  }
}

function webISopenMxOrMn (e) {  
  console.log("全屏监听", e);
  if (document.fullscreenElement) {  
    // 在这里添加全屏模式下需要执行的代码
    fullscreen.value = true; 
    store.dispatch("setfullscreen", true);
  } else {   
    fullscreen.value = false;
    store.dispatch("setfullscreen", false);
    // 在这里添加退出全屏模式下需要执行的代码  
  }  
}

// f11 监听处理
function isLikelyFullscreen() {
  return Math.abs(window.innerHeight - screen.height) < 10;
}
function handleResize() {
  // 处理窗口大小变化
  if (isLikelyFullscreen()) {
    // 如果是全屏状态
    fullscreen.value = true;
    store.dispatch("setfullscreen", true);
  } else {
    // 如果不是全屏状态
    fullscreen.value = false;
    store.dispatch("setfullscreen", false);
  }
}


onMounted(() => {
// 监听是否进入全屏 或 退出全屏
  window.addEventListener('resize', handleResize, false);
  document.addEventListener("fullscreenchange", webISopenMxOrMn, false);
  document.addEventListener("webkitfullscreenchange", webISopenMxOrMn, false);
  document.addEventListener("mozfullscreenchange", webISopenMxOrMn, false);
  document.addEventListener("MSFullscreenChange", webISopenMxOrMn, false);
});
onUnmounted(() => {
});
onBeforeUnmount(() => {
  // 移除全屏监听
  window.removeEventListener('resize', handleResize, false);
  document.removeEventListener("fullscreenchange", webISopenMxOrMn, false);
  document.removeEventListener("webkitfullscreenchange", webISopenMxOrMn, false);
  document.removeEventListener("mozfullscreenchange", webISopenMxOrMn, false);
  document.removeEventListener("MSFullscreenChange", webISopenMxOrMn, false);

});
</script>

<style lang="less" scoped>
.Wx-home {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 888;
  }
  .routerSwitch {
    position: relative;
    flex: 1;
    background: url("@/assets/beijingtu.png") no-repeat   ;
    background-size: 100% 100%;
    .fullscreen{
      display: block;
      position: absolute;
      top: 30px;
      right: 30px;
      display: flex;
      width: 60px;
      height: 60px;
      padding: 4px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      cursor: pointer;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.60);
      backdrop-filter: blur(30px);
      z-index: 200;
    }
  }

  :deep(.fixed-deepseek) {
    .deepseek-btn {
      top: -100px;
    }
  }
}
</style>
<style lang="less" >
.zhezaoA{
  width: 100% ;
  height: 100% ;
  background: rgba(255, 255, 255, 0.20);
  backdrop-filter: blur(10px);
}
.zhezao{
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.20);
  background: rgba(255, 255, 255, 0.20);
  backdrop-filter: blur(10px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
